const typeVenteOptions = [
  { key: '1', value: 'Vente au champs', text: 'Vente au champs' },
  { key: '2', value: 'Vente au village', text: 'Vente au village' },
  { key: '3', value: 'Vente au collecteur', text: 'Vente au collecteur' },
  { key: '4', value: 'Vente au centre urbain', text: 'Vente au centre urbain' },
  { key: '5', value: 'Vente usine', text: 'Vente usine' },
];

export default typeVenteOptions;
